export default __webpack_public_path__ + "static/media/adminimg.a46fdd9e.jpg";